import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import ValidatorUtils from '@core/utils/validator.utils';
import { DvDynamicFormElement } from '@devinco/ui/legacy';
import { DvCheckboxElement, DvTextboxElement } from '@devinco/ui/legacy';

@Injectable({ providedIn: 'root' })
export class FilterWithSelectionCrudDialogElementsService {
  getFormElements(): DvDynamicFormElement[] {
    return [
      new DvTextboxElement({
        colspan: 12,
        key: 'Name',
        label: 'FleetFilterCrud.Name',
        validators: [Validators.required, ValidatorUtils.noWhitespaceValidator],
      }),
      new DvCheckboxElement({
        colspan: 12,
        key: 'VisibleToAllUsers',
        checkboxLabel: 'FleetFilterCrud.VisibleToAllUsers',
      }),
    ];
  }
}
